import React, { useMemo } from 'react';

const Hero = () => {
  // const [activeCard, setActiveCard] = useState('center'); // 'left', 'center', 'right'

  const centerCard = useMemo(() => ({
    image: "/images/it-solutions.jpeg",
    title: "GxT International Consulting",
    description: "Your trusted partner in IT Security, Compliance, and Digital Transformation .",
    stats: [
      { label: "Years Experience", value: "13+" },
      { label: "Certified Experts", value: "25+" },
      { label: "Happy Clients", value: "200+" },
    ]
  }), []);

  // const leftCard = useMemo(() => ({
  //   image: "/images/security-1.jpg",
  //   title: "IT Security & Compliance",
  //   features: [
  //     "ISO 27001 Certification",
  //     "Penetration Testing",
  //     "Security Audits",
  //     "Risk Assessment",
  //     "Data Protection",
  //     "GDPR Compliance"
  //   ],
  //   cta: "Secure Your Business"
  // }), []);

  // const rightCard = useMemo(() => ({
  //   image: "/images/security-2.jpg",
  //   title: "Professional Training",
  //   features: [
  //     "Security Awareness",
  //     "Network Fundamentals",
  //     "Incident Response",
  //     "Ethical Hacking",
  //     "ISO Standards",
  //     "Custom Programs"
  //   ],
  //   cta: "Enhance Your Skills"
  // }), []);

  // Static heading
  const heading = "We Offer Expert IT Consulting & Training Solutions";
  const subtext = "Specialized in Information Security, Compliance, and Professional Development. Helping organizations build robust IT infrastructure and security-first cultures .";

  return (
    <section id="home" className="relative overflow-hidden">
      <div className="relative min-h-screen bg-gradient-to-br from-blue-900 via-blue-900 to-blue-900 flex flex-col items-center justify-center px-6 pt-16 pb-8">

        {/* Background accents */}
        <div className="absolute inset-0 opacity-10">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `
                radial-gradient(circle at 25% 25%, rgba(59,130,246,0.2) 0%, transparent 55%),
                radial-gradient(circle at 75% 75%, rgba(37,99,235,0.2) 0%, transparent 55%)
              `,
            }}
          />
        </div>

        {/* ================= TEXT SECTION ================= */}
        <div className="relative z-20 w-full max-w-6xl mx-auto mb-8">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 lg:gap-8">
            
            {/* Left side - Static Text */}
            <div className="flex-1 text-left">
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-2 text-white">
                {heading}
              </h1>

              <p className="text-base md:text-lg text-gray-200 mb-3 max-w-3xl">
                {subtext}
              </p>

              <div className="w-16 h-1 bg-gradient-to-r from-blue-400 to-blue-200 rounded-full"></div>
            </div>

            {/* Right side - CTA Buttons */}
            <div className="flex-shrink-0 flex flex-col sm:flex-row lg:flex-col xl:flex-row gap-3">
              <a
                href="#services"
                className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600 text-white px-6 py-3 rounded-lg font-semibold text-base transition-all duration-300 transform hover:scale-105 hover:shadow-2xl hover:shadow-blue-500/30 text-center whitespace-nowrap"
              >
                Our Services
              </a>

              <a
                href="#contact"
                className="border-2 border-blue-400 hover:bg-blue-400/10 text-white px-6 py-3 rounded-lg font-semibold text-base transition-all duration-300 transform hover:scale-105 hover:border-blue-300 hover:shadow-xl hover:shadow-blue-400/20 text-center whitespace-nowrap"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>

        {/* ================= CARDS ================= */}
        <div className="relative  w-full max-w-6xl h-[520px] flex items-center justify-center">
          
          {/* LEFT CARD - Temporarily hidden */}
          <div className="hidden">
            {/* Left card content - preserved for later use */}
          </div>

          {/* CENTER CARD - Original size */}
          <div className="relative w-full max-w-full h-[520px] rounded-3xl overflow-hidden
            border border-blue-500/40 bg-gray-800/50 backdrop-blur-xl
            shadow-[0_0_80px_rgba(59,130,246,0.3)] z-20">
            
            <div className="absolute inset-0 bg-gradient-to-br from-blue-600/20 to-blue-900/20 z-10"></div>
            
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{ backgroundImage: `url(${centerCard.image})` }}
            />
            
            <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/60 to-transparent z-20"></div>
            
            <div className="relative z-30 h-full flex flex-col justify-end p-8">
              {/* <div className="inline-flex items-center mb-3 bg-blue-600/20 backdrop-blur-sm rounded-full px-4 py-1.5 border border-blue-500/30 w-fit">
                <div className="w-2 h-2 rounded-full bg-blue-400 animate-pulse mr-2"></div>
                <span className="text-xs font-medium text-blue-200">Trusted </span>
              </div> */}
              
              <h3 className="text-3xl font-bold text-white mb-2">{centerCard.title}</h3>
              
              <p className="text-gray-200 text-lg mb-4 max-w-xl">
                {centerCard.description}
              </p>
              
              {/* Stats */}
              <div className="flex gap-6">
                {centerCard.stats.map((stat, index) => (
                  <div key={index}>
                    <div className="text-2xl font-bold text-white">{stat.value}</div>
                    <div className="text-xs text-gray-400">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* RIGHT CARD - Temporarily hidden */}
          <div className="hidden">
            {/* Right card content - preserved for later use */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;